import React from "react";
import MidBox from "../../../../components/Boxes/MidBox";
import WatchBoxEmptyState from "./empty-state";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import useWatch from "../../../hooks/useWatch";
import Button from "../../../../components/Button";
import { CustomIcon } from "../../../../components/Icons";
import truncateString from "../../../../utils/truncate-string";
import displayUserName from "../../../../utils/display-username";
import { useDispatch } from "react-redux";
import { CloseArenaDialog } from "../../../../redux/arena-dialog/action";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

type Props = {};

const WatchBox = (props: Props) => {
  const { battleList, connector } = useWatch();
  const { t } = useAppTranslation("battle");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <MidBox
      noMargin
      secondaryTitle
      onTitleClick={() => {
        dispatch(CloseArenaDialog());
        navigate("/arena/watch");
      }}
      className="w-100"
      containerClass="px-lg-4 "
      style={{ minHeight: 195 }}
      title={
        <div className="d-flex align-items-center gap-1">
          <img
            src="/assets/images/arena/icons/watch.png"
            width={30}
            className="mb-1"
            alt="watch-bg"
          />
          {t("dashboard.boxes.watch.title")}
        </div>
      }
    >
      <div style={{ marginTop: -20 }} className="mx-3">
        {battleList && battleList?.length > 0 ? (
          <div>
            <div className="row gap-2">
              {battleList?.map((item) => (
                <div className="col-12 d-flex rounded bg-2 justify-content-between align-items-center p-1 py-2">
                  <div>
                    {item?.attackerPlayers.map((player, index) => (
                      <div
                        className="d-flex flex-column align-items-center "
                        key={player.playerId}
                      >
                        <img
                          src={
                            player.avatar || "/assets/images/empty-avatar.png"
                          }
                          className="circle"
                          width={55}
                          height={55}
                        />
                        <div
                          style={{ maxWidth: 70 }}
                          className="fs-small text-white text-truncate"
                        >
                          {displayUserName(player.username, 7)}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div>
                    <CustomIcon icon="blades" width={25} height={25} />
                  </div>
                  {item?.defenderPlayers.map((player, index) => (
                    <div
                      className="d-flex flex-column align-items-center"
                      key={player.playerId}
                    >
                      <img
                        src={player.avatar || "/assets/images/empty-avatar.png"}
                        className="circle"
                        width={55}
                        height={55}
                      />
                      <div className="fs-small text-white">
                        {displayUserName(player.username, 7)}
                      </div>
                    </div>
                  ))}
                  <div className="d-flex  align-items-center gap-1">
                    {Boolean(item?.watchers) && item?.watchers! > 0 && (
                      <>
                        <CustomIcon icon="eye" width={20} height={14} />
                        {item?.watchers}
                      </>
                    )}
                  </div>
                  <div>
                    <Link
                      onClick={() => dispatch(CloseArenaDialog())}
                      to={`/arena/live?battleId=${item?.battleId}`}
                    >
                      <Button
                        size="small"
                        style={{ minWidth: "200px !important" }}
                        // onClick={() => connector?.watchBattle(item?.battleId)}
                        variant="primary"
                      >
                        {t("dashboard.boxes.watch.title")}
                      </Button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            style={{ minHeight: 200 }}
            className={classNames(
              "camp-box-content position-relative  bg-2 rounded-3  d-flex flex-column  p-3",
              {
                "justify-content-center align-items-center": true,
                // !isLoading && playerTroops.length === 0,
              }
            )}
          >
            <WatchBoxEmptyState />
          </div>
        )}
      </div>
      <Link
        onClick={() => dispatch(CloseArenaDialog())}
        className="w-100 text-center d-block"
        to="/arena/watch"
      >
        <a className="dark-yellow mt-2 fs-small text-center d-block font-normal ">
          {t("dashboard.actions.seeAll")}
        </a>
      </Link>
    </MidBox>
  );
};

export default WatchBox;
